import "./Error.403Layout.css";

import React, { useEffect, useState } from "react";

const Error403Layout = () => {
  const [requestedPath, setRequestedPath] = useState("");

  useEffect(() => {
    setRequestedPath(window.location.pathname || "/restricted");
  }, []);

  return (
    <div className="mt-403-wrap">
      <div className="mt-403-right">
        <div className="mt-403-card">
          <div className="mt-403-card-header">
            <p className="mt-403-big403">403</p>
            <p className="mt-403-sub">Unauthorized — Access Denied.</p>
            <div className="mt-403-meta">MathTounsi · Security Gate</div>
          </div>

          <div className="mt-403-illustration">
            <svg
              width="320"
              height="220"
              viewBox="0 0 320 220"
              xmlns="http://www.w3.org/2000/svg"
              role="img"
              aria-label="Cartoon: locked math gate"
            >
              <defs>
                <linearGradient id="g403" x1="0" x2="1">
                  <stop offset="0" stopColor="#ffffff" stopOpacity="0.95" />
                  <stop offset="1" stopColor="#fdf2f4" stopOpacity="0.9" />
                </linearGradient>
              </defs>
              <rect
                rx="14"
                width="320"
                height="220"
                fill="url(#g403)"
                opacity="0.07"
              />

              <g transform="translate(105,50)">
                <rect
                  x="0"
                  y="0"
                  width="120"
                  height="140"
                  rx="12"
                  fill="#7A0019d0"
                  stroke="#f2d4d8"
                />
                <circle
                  cx="60"
                  cy="50"
                  r="28"
                  fill="#fdf2f4"
                  stroke="#7A0019d0"
                />
                <rect
                  x="48"
                  y="70"
                  width="24"
                  height="40"
                  fill="#e43d55"
                  rx="4"
                />
              </g>

              <g fontFamily="ui-monospace,monospace" fontSize="12" fill="#7A0019">
                <text x="90" y="30">∀ u ∈ Users, u ≠ you</text>
                <text x="250" y="100">x ∉ Domain</text>
                <text x="10" y="150">Access &lt; π ?</text>
              </g>

              <ellipse
                cx="170"
                cy="190"
                rx="90"
                ry="9"
                fill="#7A0019"
                opacity="0.12"
              />
            </svg>
          </div>
        </div>
      </div>

      <div className="mt-403-left">
        <h1 style={{ color: "#8f0122ff", fontSize: "2.5em" }}>
          MathTounsi — Unauthorized
        </h1>
        <p>
          Sorry, you don’t have permission to access this page.  
          Maybe you need to log in, or request higher access rights.
        </p>

        <div className="mt-403-code">
          Requested: <strong>{requestedPath}</strong>
        </div>

        <div className="mt-403-mathbits" aria-hidden>
          <div className="mt-403-chip">x ∉ Domain</div>
          <div className="mt-403-chip">∀ u ∈ Users</div>
          <div className="mt-403-chip">¬(you ⊆ Admin)</div>
          <div className="mt-403-chip">∅ permissions</div>
        </div>

        <div className="mt-403-actions">
          <button
            className="mt-403-btn mt-403-btn-primary"
            onClick={() => (window.location.href = "/login")}
          >
            Login
          </button>
          <button
            className="mt-403-btn mt-403-btn-muted"
            onClick={() => window.history.back()}
          >
            Go back
          </button>
        </div>

        <footer className="mt-403-footer">
          Tip: check your account role or contact an administrator.
        </footer>
      </div>
    </div>
  );
};

export default Error403Layout;
